import styles from './Breadcrumbs.module.scss'
import { ReactNode } from 'react'

interface BreadcrumbsProps {
  children: ReactNode[]
}

export const Breadcrumbs = ({ children }: BreadcrumbsProps) => {
  return (
    <div className={styles.breadcrumbs}>
      {children.map((child, index) => (
        <div key={index} className={styles.breadcrumbItem}>
          {child}
        </div>
      ))}
    </div>
  )
}
